import React from "react";
import { TextInput, Flex, Button, ActionIcon } from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';

const SearchInputComponent = ({ statePlaceHolder, fnDoSearch }) => {

    const [data, setData] = React.useState({
        inputSearch: ''
    })

    return (
        <TextInput
            variant='default'
            size='sm'
            radius='md'
            placeholder={statePlaceHolder}
            value={data.inputSearch}
            onChange={(e) => setData(d => ({ ...d, inputSearch: e.target.value }))}

            styles={(tema) => ({
                rightSection: {
                    borderTopRightRadius: tema.radius.md,
                    borderBottomRightRadius: tema.radius.md,
                    width: data.inputSearch ? '4.35rem' : '0rem',
                    justifyContent: "flex-end"
                },
                input: {
                    paddingRight: data.inputSearch ? '4.25rem' : '0rem'
                }
            })}

            rightSection={
                <Flex
                    gap="0"
                    justify="flex-end"
                    align="center"
                    direction="row"
                    wrap="nowrap"
                >
                    {data.inputSearch &&
                        <ActionIcon
                            size="1.35rem"
                            radius="xl"
                            variant="filled"
                            color="blue"

                            sx={(tema) => ({
                                marginTop: '0.5rem',
                                marginBottom: '0.5rem',
                                marginRight: '0.25rem',
                                marginLeft: '0.5rem',

                                backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                            })}

                            onClick={() => {
                                setData(d => ({ ...d, inputSearch: '' }));
                                fnDoSearch('');
                            }}
                        >
                            <IconX
                                size="0.75rem"
                            />
                        </ActionIcon>
                    }

                    {data.inputSearch &&
                        <Button
                            sx={(tema) => ({
                                width: '2.25rem',
                                paddingLeft: 0,
                                paddingRight: 0,
                                borderWidth: 0,
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                borderTopRightRadius: tema.radius.md,
                                borderBottomRightRadius: tema.radius.md,
                                backgroundColor: tema.colorScheme === 'light' ? (data.inputSearch ? tema.colors.blue[5] : tema.colors.gray[4]) : (data.inputSearch ? tema.colors.blue[9] : tema.colors.dark[4]),
                            })}

                            onClick={() => fnDoSearch(data.inputSearch)}
                        >
                            <IconSearch
                                size='1rem'
                                color='#fff'
                            />
                        </Button>
                    }
                </Flex>
            }

            onKeyUp={(e) => e.key === 'Enter' && fnDoSearch(data.inputSearch)}

            py={0}
            my={0}
        />
    )
}

export default SearchInputComponent;